import React from "react"
import { Button } from "react-bootstrap"
import logoUAI from "../img/LogoUAI-black.png"
import "./SplashTour.css"

const SplashTourEnd = (props) => {
  return (
    <div className="splash-ayuda">
      <h4>Tour de ayuda {props.titulo}</h4>
      <p>¡Felicitaciones! Terminaste el tour guiado.</p>
      <p>
        Si aún necesitas ayuda{" "}
        <a href="https://experiencia.uai.cl">escríbenos</a>, de otra forma solo
        haz clic en el botón Terminar.
      </p>
    </div>
  )
}

export default SplashTourEnd
